import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { scrollToAnchor } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './TermsPage.scss';

class TermsPage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;

        return (
            <main className="conteneur conteneur-mobile" id="p-cgu">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.TERMS_PATH}`}
                />
                <LocalizedBreadcrumbItem to={PATH.TERMS_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.TITLE}</h1>

                <h3>{i18n.TITLE1}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_1)}</p>
                <p>{i18n.TEXT1_2}</p>
                <p>{i18n.TEXT1_3}</p>
                <p>{i18n.TEXT1_4}</p>
                <p>{i18n.TEXT1_5}</p>
                <p>{i18n.TEXT1_6}</p>
                <p>{i18n.TEXT1_7}</p>

                <h3>{i18n.TITLE2}</h3>
                <p>{i18n.TEXT2_1}</p>
                <p>{i18n.TEXT2_2}</p>
                <p>{i18n.TEXT2_3}</p>

                <h3>{i18n.TITLE3}</h3>
                <p>{i18n.TEXT3_1}</p>
                <ul>
                    <li>{i18n.TEXT3_2}</li>
                    <li>{i18n.TEXT3_3}</li>
                    <li>{i18n.TEXT3_4}</li>
                    <li>{i18n.TEXT3_5}</li>
                    <li>{i18n.TEXT3_6}</li>
                </ul>
                <p>{i18n.TEXT3_7}</p>
                <p>{i18n.TEXT3_8}</p>
                <p>{i18n.TEXT3_9}</p>
                <p>{i18n.TEXT3_10}</p>
                <p>{i18n.TEXT3_11}</p>
                <p>{i18n.TEXT3_12}</p>
                <p>{i18n.TEXT3_13}</p>
                <p>{i18n.TEXT3_14}</p>

                <h3>{i18n.TITLE4}</h3>
                <p>{i18n.TEXT4_1}</p>
                <p>{i18n.TEXT4_2}</p>
                <p>{i18n.TEXT4_3}</p>
                <p>{i18n.TEXT4_4}</p>
                <ul>
                    <li>{i18n.TEXT4_5}</li>
                    <li>{i18n.TEXT4_6}</li>
                    <li>{i18n.TEXT4_7}</li>
                </ul>
                <p>{i18n.TEXT4_8}</p>
                <p>{i18n.TEXT4_9}</p>
                <p>{i18n.TEXT4_10}</p>
                <p>{i18n.TEXT4_11}</p>
                <p>{i18n.TEXT4_12}</p>
                <p>{i18n.TEXT4_13}</p>
                <p>{i18n.TEXT4_14}</p>
                <p>{i18n.TEXT4_15}</p>

                <h3>{i18n.TITLE5}</h3>
                <p>{i18n.TEXT5_1}</p>
                <p>{i18n.TEXT5_2}</p>
                <p>{i18n.TEXT5_3}</p>
                <p>{i18n.TEXT5_4}</p>
                <p>{i18n.TEXT5_5}</p>
                <p>{i18n.TEXT5_6}</p>

                <h3>{i18n.TITLE6}</h3>
                <p>{i18n.TEXT6_1}</p>

                <h3>{i18n.TITLE7}</h3>
                <p>{i18n.TEXT7_1}</p>
                <p>{i18n.TEXT7_2}</p>

                <h3>{i18n.TITLE8}</h3>
                <p>{i18n.TEXT8_1}</p>
            </main>
        );
    }
}

TermsPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.TERMS
    };
}

export default withTemplate(connect(mapStateToProps)(TermsPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/terms/TermsPage.js